<template>
  <div class="BoisDAllumagePage">
    <div class="container">
      <div class="card shadow-lg p-4">

        <h2 class="text-center mb-4">Petit Bois d’Allumage</h2>

        <div class="row align-items-center">
          <div class="col-md-6 mb-3">
            <img src="@/assets/bois-allumage.jpg" alt="Petit Bois d’Allumage"
              class="img-fluid rounded shadow mx-auto d-block" style="max-height: 500px" />
          </div>

          <div class="col-md-6">
            <p class="fs-5">
              Nos sacs contiennent du bois résineux sec, parfait pour allumer rapidement vos feux ouverts, poêles ou
              barbecues.
            </p>

            <div class="alert alert-info mt-3">
              Format pratique : sacs de 40 litres (8-10kg), prêts à l’emploi.<br>
              Disponibles directement à notre dépot ou livrés avec votre commande de bois de chauffage
            </div>
            <div class="col-md-12 text-center">
              <a href="/public/contact" class="btn btn-primary mt-3">
                Nous contacter
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'BoisDAllumagePage',
  components: {
  }
}
</script>
